import HtmlReactParser from 'html-react-parser';
import Head from 'next/head';
import React from 'react';

export interface RawHtmlProps {
  rawHtmlBlock: string; // server-provided
  anchorTag?: string;
  renderInHead?: boolean;
}

export const RawHtml: React.FC<RawHtmlProps> = (props) => {
  if (!props.rawHtmlBlock) {
    return null;
  }

  if (props.renderInHead === true) {
    const parsedHead = HtmlReactParser(props.rawHtmlBlock);
    return parsedHead ? <Head>{parsedHead}</Head> : null;
  }

  return (
    <section className="module-rawhtml" {...(props.anchorTag ? { id: props.anchorTag } : {})}>
      <div
        className="Rawhtml_module-base"
        dangerouslySetInnerHTML={{ __html: props.rawHtmlBlock }}
        suppressHydrationWarning={true}
      />
    </section>
  );
};
